import { Outlet, Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { PlayerBar } from "@/components/PlayerBar";

export const Layout = () => (
  <div className="grain min-h-screen bg-[#0A0A0E] text-slate-200">
    <Header />
    <main className="pb-28 pt-16">
      <Outlet />
    </main>
    <footer className="border-t border-white/5 pb-32 pt-12">
      <div className="mx-auto flex max-w-[1400px] flex-col px-4 md:px-8 justify-between gap-6 md:flex-row">
        <div>
          <p className="font-heading text-lg font-extrabold text-white">RARA<span className="text-[#FF4500]">·</span>PERLA</p>
          <p className="mt-2 max-w-sm text-sm text-slate-500">Radio curada y difusión musical para artistas independientes de Iberoamérica.</p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-400">
          <Link to="/radio" className="hover:text-white">Radio</Link>
          <Link to="/programas" className="hover:text-white">Programas</Link>
          <Link to="/medios" className="hover:text-white">Medios</Link>
          <Link to="/creditos" className="hover:text-white">Créditos</Link>
          <Link to="/sign-up" className="hover:text-white">Soy artista</Link>
          <Link to="/suma-tu-medio" data-testid="footer-join-media" className="hover:text-white">Suma tu medio</Link>
          <Link to="/terminos" data-testid="footer-terms" className="hover:text-white">Términos</Link>
          <Link to="/privacidad" data-testid="footer-privacy" className="hover:text-white">Privacidad</Link>
        </div>
      </div>
    </footer>
    <PlayerBar />
  </div>
);
